<template>
  <section
    class="container mx-auto flex flex-col md:flex-row gap-8 md:gap-10 py-6 md:py-15"
  >
    <div class="w-full md:w-1/2">
      <h2
        class="section-heading mb-4 w-full md:w-[65%] text-center md:text-left"
      >
        Our Culture Shapes the Way We Live and Work
      </h2>
    </div>
    <div class="w-full md:w-1/2 flex flex-col gap-6">
      <template v-if="isLoading">
        <div
          v-for="i in 4"
          :key="i"
          class="flex gap-3 border-b last:border-b-0 border-[#CECED1] border-opacity-80 pb-6"
        >
          <div class="w-20 sm:w-[10%] md:w-20">
            <UtilsSkeletonLoading class="w-full h-10" />
          </div>
          <div class="flex flex-col gap-3 w-full">
            <UtilsSkeletonLoading class="w-2/5 h-10" />
            <UtilsSkeletonLoading class="w-full h-12" />
          </div>
        </div>
      </template>
      <template v-else>
        <div
          v-for="(item, i) in ourCulture.attributes?.culture"
          :key="i"
          class="flex gap-3 border-b last:border-b-0 border-[#CECED1] border-opacity-80 pb-6"
        >
          <div class="w-20 sm:w-[10%] md:w-20">
            <NuxtImg
              format="webp"
              srcset=""
              loading="lazy"
              :src="item.icon?.data?.attributes?.url"
              :alt="item.title"
              :title="item.title"
              class="w-full h-10"
            />
          </div>
          <div class="flex flex-col gap-3">
            <h3 class="text-lg text-bw-900 font-medium">{{ item.title }}</h3>
            <p class="text-base text-bw-800">
              {{ item.description }}
            </p>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script setup>
const isLoading = ref(true)

const ourCulture = ref([])

const getOurCulture = async () => {
  const { data, error, pending } = await useSuitmediaApiData(
    `/api/our-culture`,
    {
      query: {
        'populate[culture][populate][0]': 'icon'
      }
    },
    `our-culture`
  )

  isLoading.value = pending.value

  if (error.value) {
    throw createError({
      statusCode: 404,
      message: `Culture does not exist`
    })
  }

  return data.value
}

const culture = await getOurCulture()
ourCulture.value = culture.data
</script>

<style lang="scss" scoped>
:deep(.nuxt-icon) {
  svg {
    width: 42px;
    height: 42px;
  }
}
</style>
